import './style.scss';
import React from 'react';
import Icon from 'components/UI/Icon';
import classNames from 'classnames';
const nextIcon = require('img/chevron.svg');
function Button({ id, children, onClick, className, ariaLabel, shape, size, disabled, submit, variant = 'primary', }) {
    const classes = classNames({
        btn: true,
        [`btn--${variant}`]: variant,
        [`btn--${size}`]: size,
        [`btn--${shape}`]: shape,
        [`${className}`]: className,
    });
    return (React.createElement("button", { id: id, type: submit ? 'submit' : 'button', className: classes, "aria-label": ariaLabel, disabled: disabled, onTouchEnd: () => { }, onClick: onClick },
        children,
        variant === 'mobile' && React.createElement(Icon, { svg: nextIcon })));
}
export default Button;
